module.exports = __webpack_public_path__ + "static/media/bttn_list.35341aa5.svg";